import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Filter, FilterFrame, FilterSelection, GroupWrapper } from '../Filters.style';
import { FilterOption } from '../../../types';
import CheckboxSelector from '../../CheckboxComponent';
import { ExposedFiltersTypes, FilterTypes } from '../../../constants/initialFilters';
import FilterExposedHeader from '../FilterExposedHeader';
import useAnimations from '../../../hooks/Animations/useAnimations';
import { AvailableFiltersCount } from '../../../types/oneGraphTypes';

interface DrivetrainSelectorTypes {
  filterType: string;
  filterOptions: AvailableFiltersCount[];
  confirmedFilters: FilterTypes;
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string) => void;
  handleExposeFilter: (arg: string) => void;
}

const DrivetrainSelector: React.FC<DrivetrainSelectorTypes> = ({
  filterType,
  filterOptions,
  confirmedFilters,
  handleAddFilter,
  handleExposeFilter,
  openedFiltersList,
}) => {
  const { i18n } = useTranslation();

  const isEnglishPage = i18n.language === 'en';

  const selectedDrivetrains = confirmedFilters.drivetrain;

  const showFilter = openedFiltersList[filterType];

  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(showFilter);

  return (
    <Filter>
      <FilterExposedHeader
        filterType={filterType}
        selectedFilterLabels={selectedDrivetrains}
        handleExposeFilter={handleExposeFilter}
        openedFiltersList={openedFiltersList}
      />
      {dropdownAnimation(
        (props, item) =>
          item && (
            <FilterSelection style={props}>
              <FilterFrame style={filtersAccordianAnimation}>
                <GroupWrapper fullWidth>
                  {filterOptions.map((filterOption, index) => {
                    const { value, disabled } = filterOption;
                    return (
                      <CheckboxSelector
                        filterType={filterType}
                        inputName={`${filterType}-${value}`}
                        key={value}
                        onChange={() => handleAddFilter(filterType, value)}
                        value={value}
                        checked={selectedDrivetrains.includes(value)}
                        disabled={disabled}
                      />
                    );
                  })}
                </GroupWrapper>
              </FilterFrame>
            </FilterSelection>
          ),
      )}
    </Filter>
  );
};

export default DrivetrainSelector;
